export default __webpack_public_path__ + "static/real5-d57a0f7a9d02c5ab772a7dbea6e3f9ed.png";